import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  const menuItems = [
    { path: "/home", icon: "fa-solid fa-house", label: "Back To Home" },
    { path: "/address", icon: "fa-solid fa-map-marker-alt", label: "Address" },
    { path: "/messages", icon: "fa-solid fa-envelope", label: "Messages" },
    { path: "/add-billboard", icon: "fa-solid fa-square", label: "Add Billboard" },
    { path: "/add-client", icon: "fa-solid fa-users", label: "Add Client" },
  ];

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/home");
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // على الشاشات الكبيرة، نفتح الشريط الجانبي تلقائياً
      if (!mobile) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      {/* زر القائمة للهواتف المحمولة */}
      {isMobile && (
        <button className="mobile-toggle" onClick={toggleSidebar}>
          <i className={`fa-solid ${sidebarOpen ? "fa-xmark" : "fa-bars"}`}></i>
        </button>
      )}

      {/* طبقة التعتيم للهواتف المحمولة */}
      {isMobile && sidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      {/* الشريط الجانبي */}
      <div className={`sidebar ${sidebarOpen ? "sidebar-open" : "sidebar-closed"} ${isMobile ? "mobile-sidebar" : ""}`}>
        <div className="sidebar-header">
          <h2>Admin Dashboard</h2>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? "active" : ""}`}
              onClick={() => isMobile && setSidebarOpen(false)}
            >
              <i className={`nav-icon ${item.icon}`}></i>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}

          {/* زرار اللوج آوت */}
          <button onClick={handleLogout} className="nav-item logout-btn">
            <i className="nav-icon fa-solid fa-right-from-bracket"></i>
            <span className="nav-label">Logout</span>
          </button>
        </nav>

        <div className="sidebar-footer">
          <p>Spark Media © 2024</p>
        </div>
      </div>
    </>
  );
};

export default Sidebar;